import { render, staticRenderFns } from "./OrderSteps.vue?vue&type=template&id=205a967c&scoped=true&"
import script from "./OrderSteps.vue?vue&type=script&lang=js&"
export * from "./OrderSteps.vue?vue&type=script&lang=js&"
import style0 from "./OrderSteps.vue?vue&type=style&index=0&id=205a967c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a967c",
  null
  
)

export default component.exports